import { render, staticRenderFns } from "./TelegramBotUsersListing.vue?vue&type=template&id=b08c61c4&scoped=true"
import script from "./TelegramBotUsersListing.vue?vue&type=script&lang=js"
export * from "./TelegramBotUsersListing.vue?vue&type=script&lang=js"
import style0 from "./TelegramBotUsersListing.vue?vue&type=style&index=0&id=b08c61c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c61c4",
  null
  
)

export default component.exports